<template lang="pug">
.v-product.product

	template(v-if="template === 'compare-grid-small'")
		.product-c-grid.product-c-grid--small
			a.product-c-grid__link(v-if="product.link" :href="product.link" :aria-label="product.name")
			.product-c-grid__card
				.product-c-grid__main
					.product-c-grid__visual.flc
						v-product-image.product-c-grid__image(:src="product.image.medium" :sources="computedSourcesMedium")
					.product-c-grid__info
						.product-c-grid__name.flc(v-if="product.name") {{product.name}}
						.product-c-grid__price
							v-price(:price="product.price")

	template(v-if="template === 'compare-grid'")
		.product-c-grid
			a.product-c-grid__link(v-if="product.link" :href="product.link" :aria-label="product.name")
			.product-c-grid__card
				button.btn-del(type="button", aria-label="Удалить" @click="removeFromCompare")
					v-svg-icon.btn-del__icon(icon="close")
				.product-c-grid__top
					.product-c-grid__visual.flc
						v-product-image.product-c-grid__image(:src="product.image.medium" :sources="computedSourcesMedium")
					.product-c-grid__name.flc(v-if="product.name") {{product.name}}
					a.product__admin-link.link(v-if="product.adminlink" :href="product.adminlink") В админке
				.product-c-grid__bottom
					.product-c-grid__action.flc
						v-basket-action(:id="product.id"
								:inquire-about-admission-link="product.inquireAboutAdmissionLink"
								:can-buy="product.canBuy"
								:preorder-link="product.preorderLink"
								:trade-offer="product.tradeOffer"
								:product-link="product.link"
								:product-modal-url="product.productModalUrl")

	template(v-if="template === 'grid'")
		.product-t-grid
			a.product-t-grid__link(v-if="product.link" :href="product.link" @click="openDetails" :aria-label="product.name")
			.product-t-grid__favorite-action
				v-favorite-action(:id="product.id" :name="product.name" :model="product.model")
			.product-t-grid__card
				.product-t-grid__top
					.product-t-grid__visual.flc
						v-product-image.product-t-grid__image(:src="product.image ? product.image.medium : null" :sources="computedSourcesMedium")
						.product-t-grid__status(v-if="product.status && product.status.length")
							v-status(:status="product.status")
					.product-t-grid__name.flc(v-if="product.name") {{product.name}}
					.product-t-grid__avail.flc(v-if="product.availability")
						v-availability(:availability="product.availability")
				.product-t-grid__bottom
					.product-t-grid__price.flc(v-if="product.price")
						v-price(:price="product.price")
					.product-t-grid__action.flc
						v-basket-action(:id="product.id")

	template(v-if="template === 'list'")
		.product-t-list
			.product-t-list__card(:class="product.className")
				.product-t-list__cell-visual
					.product-t-list__visual.flc
						template(v-if="product.slides && product.slides.length > 1")
							v-small-slider(:data-source='{"items": product.slides}')
						template(v-if="product.slides && product.slides.length === 1")
							//.product-t-list__visual-wrap(:style="{backgroundImage: product.image.src ? `url(${product.image.src})` : '#FFFFFF' }")
							img.product-t-list__image(
								:src="product.slides[0].src"
								:alt="product.slides[0].alt"
								loading="lazy")
				.product-t-list__cell-info(v-if="!is3Xs")
					.product-t-list__status(v-if="product.status && product.status.length")
						v-status(:status="product.status")
					.product-t-list__name
						.product-t-list__head
							span.product-t-list__title(v-if="product.title")
								span.product-t-list__title-text(v-if="product.title.text") {{ product.title.text }}
								span.product-t-list__title-value(v-if="product.title.value") , {{ product.title.value }}
								span.product-t-list__title-postfix(v-if="product.title.postfix") &nbsp;{{ product.title.postfix }}
							span.product-t-list__id(v-if="product.id") ID: {{ product.id }}
						.product-t-list__location.location(v-if="product.location")
							v-svg-icon.location-icon(v-if="product.location.icon" :icon="product.location.icon")
							span.location-region(v-if="product.location.region" ) {{ product.location.region }}
							span.location-district(v-if="product.location.district" ) , {{ product.location.district }}
					.product-t-list__items.info-items(v-if="product.items" )
						.info-items__item(v-for="(item, index) in product.items" :key="index" :style="{width: item.width || null}")
							span.info-items__title(v-if="item.title" ) {{ item.title }}
							.info-items__block
								span.info-items__value(v-if="item.value" ) {{ item.value }}
								span.info-items__postfix(v-if="item.postfix" ) &nbsp;{{ item.postfix }}
								a.info-items__link(v-if="item.link" :href="item.link?.href" :target="item.link?.target") {{ item.link?.text }}
					.product-t-list__actions
						v-favorite-action.product-t-list__favorite(
							:id="product.id"
							:name="product.title?.text"
							:model="product.model"
							:favorite="product.favorite")
						a.product-t-list__link(v-if="product.link.href" :href="product.link.href") {{ product.link.text }}
				.product-t-list__cell-price-action(v-if="!is3Xs")
					.product-t-list__cell-card
						.product-t-list__cell-price
							.product-t-list__price.flc(v-if="product.price")
								v-price(:price="product.price")
						.product-t-list__note(v-if="product.note") {{ product.note }}
						.product-t-list__owner(v-if="product.owner")
							img.product-t-list__owner-image(v-if="product.owner.image"
								:src="product.owner.image?.src"
								:alt="product.owner.image?.alt")
							.product-t-list__owner-name(v-if="product.owner.name" v-html="product.owner.name" )
						img.product-t-list__owner-icon(v-if="product.icon"
							:src="product.icon?.src"
							:alt="product.icon?.alt")
						template(v-if="product.buttons" )
							button.product-t-list__owner-contact(v-for="(button, index) in product.buttons"
								:key="index"
								:type="button.type"
								:class="button.class"
								@click="button.event ? isNumberVisible = true : null")
								a.product-t-list__owner-contact-link(v-if="isNumberVisible"
									:href="`tel:${button.hiddenText}`")
									| {{ button.hiddenText }}
								span(v-else) {{ button.text }}
					.product-t-list__cell-date(v-if="product.date" ) {{ `${product.date?.prefix} ${product.date?.text}` }}



				.product-t-list__cell-mobile(v-if="is3Xs" )
					a.product-t-list__cell-mobile-link(v-if="product.link.href" :href="product.link.href")
					.product-t-list__cell-price
						.product-t-list__price.flc(v-if="product.price")
							v-price(:price="product.price")
					.product-t-list__name
						.product-t-list__head
							span.product-t-list__title(v-if="product.title")
								span.product-t-list__title-text(v-if="product.title.text") {{ product.title.text }}
								span.product-t-list__title-value(v-if="product.title.value") , {{ product.title.value }}
								span.product-t-list__title-postfix(v-if="product.title.postfix") &nbsp;{{ product.title.postfix }}
							span.product-t-list__id(v-if="product.id") ID: {{ product.id }}
						.product-t-list__type(v-if="product.productType") {{ product.productType }}
						.product-t-list__location.location(v-if="product.location")
							v-svg-icon.location-icon(v-if="product.location.icon" :icon="product.location.icon")
							span.location-region(v-if="product.location.region" ) {{ product.location.region }}
							span.location-district(v-if="product.location.district" ) , {{ product.location.district }}
					img.product-t-list__owner-icon(v-if="product.icon"
						:src="product.icon?.src"
						:alt="product.icon?.alt")

	template(v-if="template === 'map-list'")
		.product-m-list(:class="product.className")
			.product-m-list__card
				a.product-m-list__link(v-if="product.link" :href="product.link?.href")
				.product-m-list__status(v-if="product.status && product.status.length")
					v-status(:status="product.status")
				.product-m-list__cell-visual
					.product-m-list__visual.flc
						template(v-if="product.slides && product.slides.length > 1")
							v-small-slider(:data-source='{"items": product.slides}')
						template(v-if="product.slides && product.slides.length === 1")
							//.product-m-list__visual-wrap(:style="{backgroundImage: product.image.src ? `url(${product.image.src})` : '#FFFFFF' }")
							img.product-m-list__image(
								:src="product.slides[0].src"
								:alt="product.slides[0].alt")
				.product-m-list__cell-info
					.product-m-list__cell-price
						.product-m-list__price.flc(v-if="product.price")
							v-price(:price="product.price")
					.product-m-list__title(v-if="product.title")
						span.product-m-list__title-text(v-if="product.title.text" v-html="product.title.text")
						span.product-m-list__title-value(v-if="product.title.value") , {{ product.title.value }}
						span.product-m-list__title-postfix(v-if="product.title.postfix") &nbsp;{{ product.title.postfix }}
					.product-m-list__location(v-if="product.location")
						span.product-m-list__location-text(v-if="product.location.region") {{ product.location.region }}
						span.product-m-list__location-text(v-if="product.location.district") ,&nbsp{{ product.location.district }}
					.product-m-list__cell-card(v-if="is2Xs" :class="product.className")
						.product-m-list__owner(v-if="product.owner")
							img.product-m-list__owner-image(v-if="product.owner.image"
								:src="product.owner.image?.src"
								:alt="product.owner.image?.alt")
							.product-m-list__owner-name(v-if="product.owner.name" v-html="product.owner.name" )
						img.product-m-list__owner-icon(v-if="product.icon"
							:src="product.icon?.src"
							:alt="product.icon?.alt")
			.product-m-list__cell-card(v-if="!is2Xs" :class="product.className")
				.product-m-list__owner(v-if="product.owner")
					img.product-m-list__owner-image(v-if="product.owner.image"
						:src="product.owner.image?.src"
						:alt="product.owner.image?.alt")
					.product-m-list__owner-name(v-if="product.owner.name" v-html="product.owner.name" )
				img.product-m-list__owner-icon(v-if="product.icon"
					:src="product.icon?.src"
					:alt="product.icon?.alt")
				//template(v-if="product.buttons" )
				//	button.product-m-list__owner-contact(v-for="(button, index) in product.buttons"
				//		:key="index"
				//		:type="button.type"
				//		:class="button.class"
				//		@click="button.event ? isNumberVisible = true : null")
				//		a.product-t-list__owner-contact-link(v-if="isNumberVisible"
				//			:href="`tel:${button.hiddenText}`")
				//			| {{ button.hiddenText }}
				//		span(v-else) {{ button.text }}



	template(v-if="template === 'basket-list'")
		.product-t-list
			a.product-t-list__link(v-if="product.link" :href="product.link" @click="openDetails")
			.product-t-list__card
				.product-t-list__cell-visual
					.product-t-list__visual.flc
						v-product-image.product-t-list__image(:src="product.image" :sources="product.imageSources")
						.product-t-list__status(v-if="product.status && product.status.length")
							v-status(:status="product.status")
				.product-t-list__cell-info
					.product-t-list__name.flc(v-if="product.name") {{product.name}}
					.product-t-list__avail.flc(v-if="product.availability")
						v-availability(:availability="product.availability")
				.product-t-list__cell-price-action
					.product-t-list__cell-price
						.product-t-list__price.flc(v-if="product.price")
							v-price(:price="product.price")
					.product-t-list__cell-action
						.product-t-list__action.flc
							v-basket-action(:id="product.id")
						.product-t-list__action
							button.product-t-list__delete-btn.link(type="button" @click="deleteBasketItem") Удалить
</template>

<script>
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		isMobMixin
	],

	props: {
		product: {
			type: Object,
			default: null
		},

		template: {
			type: String,
			default: 'grid'
		},

		quickView: {
			type: Boolean,
			default: false
		}
	},

	emits: [
		'delete-product'
	],

	data() {
		return {
			isNumberVisible: false
		}
	},

	computed: {
		computedSourcesMedium() {
			let result = null;
			if (this.product.image) {
				result = [
					{
						'src': this.product.image.medium,
						'size': '1x'
					},
					{
						'src': this.product.image.medium_2x,
						'size': '2x'
					}
				];
			}
			return result;
		},

		computedSourcesBig(item) {
			return [
				{
					'src': item.big,
					'size': '1x'
				},
				{
					'src': item.big_2x,
					'size': '2x'
				}
			];
		},
	},

	methods: {
		deleteBasketItem() {
			this.$emit('delete-product', this.product.id);
		},

		openDetails(e) {
			if (this.quickView) {
				e.preventDefault();
				controller.openModal({
					className: 'modal--page',
					historyUrl: this.product.link,
					component: {
						name: 'v-catalog-item',
						props: {
							dataSource: this.product.quickViewLink
						}
					}
				});
			}
		}
	}
};
</script>